import LeaveRoutes from "./leave/routes";
const Exemption = () => import("./exemption/views/Exemption.vue");
import ExemptionRoutes from "./exemption/routes";
import ReportRoutes from "./reports/routes";
import AppraisalsRoutes from "./appraisal/routes";

export default [
  {
    path: "exemption",
    redirect: "/ess/hrm/exemption/my-exemptions",
    component: Exemption,
    children: ExemptionRoutes,
  },
  {
    path: "leave",
    redirect: "/ess/hrm/leave/my-leaves",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: LeaveRoutes,
  },

  {
    path: "reports",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/ess/hrm/reports/generate",
    children: ReportRoutes,
  },
  {
    path: "appraisal",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/ess/hrm/appraisal/my-appraisals",
    children: AppraisalsRoutes,
  },
];
